import { useEffect } from 'react'
import AnimatedLoader from '../shared_components/AnimatedLoader'
import { Box } from '../shared_components/UI/Box'
import { toast } from 'react-toastify'
import { FullPageContainer } from './TwitterAuth'
import { useHistory } from 'react-router-dom'

const DiscordAuth = () => {
  const history = useHistory()

  useEffect(() => {
    try {
      const launchedFrom = localStorage.getItem('launched_from')

      if (!launchedFrom) throw new Error('No launched from')
      localStorage.removeItem('launched_from')
      toast.error('There was an error connecting to Discord')
      history.replace(launchedFrom, { skipHistoryUpdate: true })
    } catch (err) {
      console.error(err)
      window.location.href = '/account'
    }
  }, [history])

  return (
    <FullPageContainer>
      <Box center>
        <AnimatedLoader onlyWhite />
      </Box>
    </FullPageContainer>
  )
}

export default DiscordAuth
